import { Flex as UIFlex, Icon } from "@evergis/ui";
import styled, { css } from "styled-components";

export const ResourceTypes = styled(UIFlex)`
  background-color: ${({ theme: { palette } }) => palette.element};
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  width: 100%;
`;

export const ResourceTypeContainer = styled(UIFlex)<{ selected: boolean; disabled?: boolean; width?: string }>`
  height: 5.25rem;
  width: ${({ width }) => width || "16.5rem"};
  flex-direction: column;
  background-color: ${({ theme: { palette } }) => palette.background};
  margin-right: 1rem;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: ${({ theme: { palette } }) => palette.textSecondary};
  border: 1px solid white;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  }
  ${({ selected }) =>
    selected
      ? css`
          color: ${({ theme: { palette } }) => palette.primary};
          border: 1px solid ${({ theme: { palette } }) => palette.primary};
        `
      : ""}
  ${({ disabled }) =>
    disabled
      ? css`
          cursor: default;
          pointer-events: none;
          color: ${({ theme: { palette } }) => palette.textSecondary} !important;
          border: 1px solid white !important;
          &:hover {
            box-shadow: none;
          }
        `
      : ""}
`;

export const ResourceTypeIcon = styled(Icon)`
  width: 1.5rem;
  height: 1.5rem;

  &:after {
    font-size: 1.5rem;
  }
`;

export const ResourceTypeTitle = styled.label`
  font-size: 14px;
  margin-top: 0.75rem;
  cursor: pointer;
`;
